import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {isMobile} from 'react-device-detect';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {useDebtPaymentPopupData} from '../../hooks/useDebtPaymentPopupData';
import {selectSelectedBanData, selectServerData, selectEpiData} from '../../DebtAndUpdatePaymentBlockSlice';
import {dwhUpdatePaymentMethodReport, DwhActionType, DWHMessageText, DWHStatus} from '../../reports/dwhReports';
import Image from 'app/Components/Shared/Image/image';

const SignatureRequiredPopup = () => {
  const {actions} = useDebtPaymentPopupData();
  const selectedBanData = useSelector(selectSelectedBanData);
  const allBans = useSelector(selectServerData);
  const epiData = useSelector(selectEpiData);
  const loginData = useSelector((state) => state.authentication.loginData);
  const selectedBansForPaymentUpdate = useSelector((state) => state.debtAndUpdatePayment.selectedBansForPaymentUpdate);

  useEffect(() => {
    dwhUpdatePaymentMethodReport({
      banData: selectedBanData,
      loginData,
      allBans,
      selectedBanNumbers: selectedBansForPaymentUpdate,
      actionType: DwhActionType.SettingStandingOrder,
      messageText: DWHMessageText.SigningFormErrorPopupDisplayed,
      status: DWHStatus.Error,
      lastPaymentTypeValidation: epiData?.lastPaymentTypeValidation,
    });
  }, []);

  const handleClose = () => {
    actions.setShowPopup({showPopUp: false});
  };

  return (
    <div className='signature-required-popup'>
      <div className='debt-payment-popup-image'>
        <Image src={require('../../images/error.svg')} alt='' />
      </div>
      <div className={`popup-title ${isMobile ? 'm-title' : 'l-title'}`}>החתימה לא נקלטה</div>
      <div className='signature-required-popup__text'>
        המערכת לא זיהתה את החתימה,
        <br />
        יש לחזור לטופס ולחתום בשנית
      </div>
      <div className='debt-payment-popup-actions'>
        <BtnSubmit onclick={handleClose} text='חזרה לטופס' />
      </div>
    </div>
  );
};

export default SignatureRequiredPopup;
